import { TAO6PretrainedModel } from "./types";


export const TAO6_PRETRAINED_MODELS: TAO6PretrainedModel[] = [
  // Object Detection Models
  {
    id: 'yolov8_n',
    name: 'yolov8_nano',
    displayName: 'YOLOv8 Nano',
    task: 'object_detection',
    backbone: 'yolov8_n',
    description: 'Ultra-lightweight real-time detection model for edge devices',
    accuracy: 37.3,
    accuracyMetric: 'mAP',
    vramRequired: 4,
    inputSize: '640x640',
    parameters: '3.2M',
    ngcPath: 'nvidia/tao/yolov8_nano',
    supportedAugmentations: ['mosaic', 'mixup', 'random_flip', 'hsv_augment'],
    supportsQAT: true,
    supportsKD: true,
    pretrainedDataset: 'COCO 2017',
    pretrainedClasses: 80,
    useCases: ['Edge deployment', 'IoT devices', 'Real-time mobile applications', 'Embedded systems'],
    strengths: ['Extremely fast inference', 'Very low memory footprint', 'Ideal for resource-constrained devices', 'Easy to deploy on edge'],
    limitations: ['Lower accuracy on small objects', 'May miss objects in complex scenes', 'Limited performance on crowded images'],
    paperReference: 'https://arxiv.org/abs/2305.09972',
    license: 'AGPL-3.0',
  },
  {
    id: 'yolov8_s',
    name: 'yolov8_small',
    displayName: 'YOLOv8 Small',
    task: 'object_detection',
    backbone: 'yolov8_s',
    description: 'Balanced detection model for general use cases',
    accuracy: 44.9,
    accuracyMetric: 'mAP',
    vramRequired: 6,
    inputSize: '640x640',
    parameters: '11.2M',
    ngcPath: 'nvidia/tao/yolov8_small',
    supportedAugmentations: ['mosaic', 'mixup', 'random_flip', 'hsv_augment'],
    supportsQAT: true,
    supportsKD: true,
    pretrainedDataset: 'COCO 2017',
    pretrainedClasses: 80,
    useCases: ['General object detection', 'Video surveillance', 'Retail analytics', 'Traffic monitoring'],
    strengths: ['Good speed-accuracy balance', 'Versatile for many applications', 'Works well on mid-range GPUs', 'Strong small object detection'],
    limitations: ['Not optimal for very large images', 'May struggle with extreme occlusion'],
    paperReference: 'https://arxiv.org/abs/2305.09972',
    license: 'AGPL-3.0',
  },
  {
    id: 'yolov8_m',
    name: 'yolov8_medium',
    displayName: 'YOLOv8 Medium',
    task: 'object_detection',
    backbone: 'yolov8_m',
    description: 'High-accuracy detection model for production workloads',
    accuracy: 50.2,
    accuracyMetric: 'mAP',
    vramRequired: 10,
    inputSize: '640x640',
    parameters: '25.9M',
    ngcPath: 'nvidia/tao/yolov8_medium',
    supportedAugmentations: ['mosaic', 'mixup', 'random_flip', 'hsv_augment'],
    supportsQAT: true,
    supportsKD: true,
    pretrainedDataset: 'COCO 2017',
    pretrainedClasses: 80,
    useCases: ['Production deployment', 'Autonomous vehicles', 'Industrial inspection', 'Security systems'],
    strengths: ['High accuracy', 'Good for production environments', 'Robust detection across scales', 'Excellent for fine-tuning'],
    limitations: ['Requires dedicated GPU', 'Higher latency than smaller variants'],
    paperReference: 'https://arxiv.org/abs/2305.09972',
    license: 'AGPL-3.0',
  },
  {
    id: 'yolov8_l',
    name: 'yolov8_large',
    displayName: 'YOLOv8 Large',
    task: 'object_detection',
    backbone: 'yolov8_l',
    description: 'Enterprise-grade detection with maximum accuracy',
    accuracy: 52.9,
    accuracyMetric: 'mAP',
    vramRequired: 16,
    inputSize: '640x640',
    parameters: '43.7M',
    ngcPath: 'nvidia/tao/yolov8_large',
    supportedAugmentations: ['mosaic', 'mixup', 'random_flip', 'hsv_augment'],
    supportsQAT: true,
    supportsKD: true,
    pretrainedDataset: 'COCO 2017',
    pretrainedClasses: 80,
    useCases: ['High-stakes applications', 'Medical imaging', 'Satellite imagery', 'Quality control'],
    strengths: ['Very high accuracy', 'Excellent small object detection', 'Robust to domain shift', 'Best for accuracy-critical tasks'],
    limitations: ['High GPU memory requirement', 'Slower inference speed', 'Not suitable for edge deployment'],
    paperReference: 'https://arxiv.org/abs/2305.09972',
    license: 'AGPL-3.0',
  },
  {
    id: 'dino_resnet50',
    name: 'dino_resnet50',
    displayName: 'DINO ResNet-50',
    task: 'object_detection',
    backbone: 'dino_resnet50',
    description: 'Transformer-based detection with ResNet-50 backbone',
    accuracy: 49.4,
    accuracyMetric: 'mAP',
    vramRequired: 12,
    inputSize: '800x1333',
    parameters: '47M',
    ngcPath: 'nvidia/tao/dino_resnet50',
    supportedAugmentations: ['random_flip', 'random_crop', 'color_jitter'],
    supportsQAT: false,
    supportsKD: true,
    pretrainedDataset: 'COCO 2017',
    pretrainedClasses: 80,
    useCases: ['Dense object detection', 'Document analysis', 'Aerial imagery', 'Multi-scale detection'],
    strengths: ['End-to-end detection', 'No NMS required', 'Good for crowded scenes', 'Strong multi-scale features'],
    limitations: ['Longer training time', 'Higher memory during training', 'Complex architecture'],
    paperReference: 'https://arxiv.org/abs/2203.03605',
    license: 'Apache 2.0',
  },
  {
    id: 'dino_swin',
    name: 'dino_swin_base',
    displayName: 'DINO Swin-Base',
    task: 'object_detection',
    backbone: 'dino_swin',
    description: 'State-of-the-art detection with Swin Transformer',
    accuracy: 55.8,
    accuracyMetric: 'mAP',
    vramRequired: 24,
    inputSize: '800x1333',
    parameters: '110M',
    ngcPath: 'nvidia/tao/dino_swin_base',
    supportedAugmentations: ['random_flip', 'random_crop', 'color_jitter'],
    supportsQAT: false,
    supportsKD: true,
    pretrainedDataset: 'COCO 2017',
    pretrainedClasses: 80,
    useCases: ['Research benchmarks', 'High-accuracy requirements', 'Complex scene understanding', 'Fine-grained detection'],
    strengths: ['State-of-the-art accuracy', 'Excellent feature learning', 'Best for complex scenes', 'Strong transfer learning'],
    limitations: ['Very high GPU requirements', 'Slow inference', 'Complex to deploy', 'Expensive to train'],
    paperReference: 'https://arxiv.org/abs/2203.03605',
    license: 'Apache 2.0',
  },
  {
    id: 'rtdetr_r50',
    name: 'rtdetr_resnet50',
    displayName: 'RT-DETR ResNet-50',
    task: 'object_detection',
    backbone: 'rtdetr_r50',
    description: 'Real-time transformer detector optimized for speed',
    accuracy: 53.1,
    accuracyMetric: 'mAP',
    vramRequired: 10,
    inputSize: '640x640',
    parameters: '42M',
    ngcPath: 'nvidia/tao/rtdetr_r50',
    supportedAugmentations: ['random_flip', 'random_crop', 'mosaic'],
    supportsQAT: true,
    supportsKD: true,
    pretrainedDataset: 'COCO 2017',
    pretrainedClasses: 80,
    useCases: ['Real-time applications', 'Video analytics', 'Robotics', 'Autonomous systems'],
    strengths: ['Fast transformer-based detection', 'No NMS post-processing', 'Good accuracy-speed tradeoff', 'TensorRT optimized'],
    limitations: ['Requires careful hyperparameter tuning', 'May need more training data'],
    paperReference: 'https://arxiv.org/abs/2304.08069',
    license: 'Apache 2.0',
  },
  // Image Classification Models
  {
    id: 'resnet_50',
    name: 'resnet_50',
    displayName: 'ResNet-50',
    task: 'image_classification',
    backbone: 'resnet_50',
    description: 'Classic CNN backbone for image classification',
    accuracy: 80.4,
    accuracyMetric: 'top1',
    vramRequired: 4,
    inputSize: '224x224',
    parameters: '25.6M',
    ngcPath: 'nvidia/tao/resnet_50',
    supportedAugmentations: ['random_crop', 'random_flip', 'color_jitter', 'cutout'],
    supportsQAT: true,
    supportsKD: true,
    pretrainedDataset: 'ImageNet-1K',
    pretrainedClasses: 1000,
    useCases: ['General image classification', 'Feature extraction', 'Transfer learning base', 'Medical imaging'],
    strengths: ['Well-understood architecture', 'Excellent transfer learning', 'Wide community support', 'Good baseline performance'],
    limitations: ['Less efficient than modern architectures', 'May overfit on small datasets'],
    paperReference: 'https://arxiv.org/abs/1512.03385',
    license: 'Apache 2.0',
  },
  {
    id: 'resnet_101',
    name: 'resnet_101',
    displayName: 'ResNet-101',
    task: 'image_classification',
    backbone: 'resnet_101',
    description: 'Deeper ResNet variant for higher accuracy',
    accuracy: 81.9,
    accuracyMetric: 'top1',
    vramRequired: 6,
    inputSize: '224x224',
    parameters: '44.5M',
    ngcPath: 'nvidia/tao/resnet_101',
    supportedAugmentations: ['random_crop', 'random_flip', 'color_jitter', 'cutout'],
    supportsQAT: true,
    supportsKD: true,
    pretrainedDataset: 'ImageNet-1K',
    pretrainedClasses: 1000,
    useCases: ['Fine-grained classification', 'Complex image understanding', 'Backbone for detection', 'Feature extraction'],
    strengths: ['Higher accuracy than ResNet-50', 'More expressive features', 'Good for complex tasks'],
    limitations: ['Higher computational cost', 'Longer training time'],
    paperReference: 'https://arxiv.org/abs/1512.03385',
    license: 'Apache 2.0',
  },
  {
    id: 'efficientnet_b0',
    name: 'efficientnet_b0',
    displayName: 'EfficientNet-B0',
    task: 'image_classification',
    backbone: 'efficientnet_b0',
    description: 'Efficient model with compound scaling',
    accuracy: 77.1,
    accuracyMetric: 'top1',
    vramRequired: 2,
    inputSize: '224x224',
    parameters: '5.3M',
    ngcPath: 'nvidia/tao/efficientnet_b0',
    supportedAugmentations: ['random_crop', 'random_flip', 'autoaugment'],
    supportsQAT: true,
    supportsKD: true,
    pretrainedDataset: 'ImageNet-1K',
    pretrainedClasses: 1000,
    useCases: ['Mobile deployment', 'Edge inference', 'Resource-constrained environments', 'Real-time classification'],
    strengths: ['Very efficient', 'Low memory footprint', 'Fast inference', 'Good accuracy for size'],
    limitations: ['Lower accuracy than larger models', 'May need more augmentation'],
    paperReference: 'https://arxiv.org/abs/1905.11946',
    license: 'Apache 2.0',
  },
  {
    id: 'efficientnet_b4',
    name: 'efficientnet_b4',
    displayName: 'EfficientNet-B4',
    task: 'image_classification',
    backbone: 'efficientnet_b4',
    description: 'High-accuracy EfficientNet variant',
    accuracy: 82.9,
    accuracyMetric: 'top1',
    vramRequired: 8,
    inputSize: '380x380',
    parameters: '19M',
    ngcPath: 'nvidia/tao/efficientnet_b4',
    supportedAugmentations: ['random_crop', 'random_flip', 'autoaugment'],
    supportsQAT: true,
    supportsKD: true,
    pretrainedDataset: 'ImageNet-1K',
    pretrainedClasses: 1000,
    useCases: ['Production classification', 'Medical imaging', 'Quality inspection', 'Document classification'],
    strengths: ['Excellent accuracy-efficiency ratio', 'Strong feature learning', 'Works well with augmentation'],
    limitations: ['Requires more VRAM than B0-B3', 'Longer training time'],
    paperReference: 'https://arxiv.org/abs/1905.11946',
    license: 'Apache 2.0',
  },
  {
    id: 'vit_base',
    name: 'vit_base_patch16',
    displayName: 'ViT-Base/16',
    task: 'image_classification',
    backbone: 'vit_base',
    description: 'Vision Transformer with 16x16 patches',
    accuracy: 84.5,
    accuracyMetric: 'top1',
    vramRequired: 12,
    inputSize: '384x384',
    parameters: '86M',
    ngcPath: 'nvidia/tao/vit_base_16',
    supportedAugmentations: ['random_crop', 'random_flip', 'mixup', 'cutmix'],
    supportsQAT: false,
    supportsKD: true,
    pretrainedDataset: 'ImageNet-21K',
    pretrainedClasses: 21843,
    useCases: ['High-accuracy classification', 'Transfer learning', 'Multi-modal applications', 'Research'],
    strengths: ['Excellent global context', 'Strong transfer learning', 'State-of-the-art performance', 'Scales well with data'],
    limitations: ['Requires large datasets', 'High computational cost', 'Needs careful regularization'],
    paperReference: 'https://arxiv.org/abs/2010.11929',
    license: 'Apache 2.0',
  },
  {
    id: 'swin_tiny',
    name: 'swin_tiny',
    displayName: 'Swin-Tiny',
    task: 'image_classification',
    backbone: 'swin_tiny',
    description: 'Lightweight Swin Transformer',
    accuracy: 81.3,
    accuracyMetric: 'top1',
    vramRequired: 6,
    inputSize: '224x224',
    parameters: '28M',
    ngcPath: 'nvidia/tao/swin_tiny',
    supportedAugmentations: ['random_crop', 'random_flip', 'mixup', 'cutmix'],
    supportsQAT: false,
    supportsKD: true,
    pretrainedDataset: 'ImageNet-1K',
    pretrainedClasses: 1000,
    useCases: ['Efficient transformer classification', 'Dense prediction tasks', 'Video understanding', 'Multi-scale features'],
    strengths: ['Efficient attention mechanism', 'Good local-global features', 'Works well on various scales'],
    limitations: ['More complex than CNNs', 'Requires proper warmup'],
    paperReference: 'https://arxiv.org/abs/2103.14030',
    license: 'MIT',
  },
  {
    id: 'swin_base',
    name: 'swin_base',
    displayName: 'Swin-Base',
    task: 'image_classification',
    backbone: 'swin_base',
    description: 'Standard Swin Transformer for high accuracy',
    accuracy: 85.2,
    accuracyMetric: 'top1',
    vramRequired: 16,
    inputSize: '384x384',
    parameters: '88M',
    ngcPath: 'nvidia/tao/swin_base',
    supportedAugmentations: ['random_crop', 'random_flip', 'mixup', 'cutmix'],
    supportsQAT: false,
    supportsKD: true,
    pretrainedDataset: 'ImageNet-22K',
    pretrainedClasses: 21841,
    useCases: ['High-accuracy requirements', 'Research benchmarks', 'Complex visual tasks', 'Foundation model backbone'],
    strengths: ['State-of-the-art accuracy', 'Excellent feature hierarchy', 'Strong dense prediction', 'Good transfer learning'],
    limitations: ['High GPU memory', 'Slower inference than CNNs', 'Complex training setup'],
    paperReference: 'https://arxiv.org/abs/2103.14030',
    license: 'MIT',
  },
  // Additional Object Detection Models
  {
    id: 'yolov8_x',
    name: 'yolov8_xlarge',
    displayName: 'YOLOv8 X-Large',
    task: 'object_detection',
    backbone: 'yolov8_x',
    description: 'Maximum accuracy YOLOv8 for demanding applications',
    accuracy: 53.9,
    accuracyMetric: 'mAP',
    vramRequired: 24,
    inputSize: '640x640',
    parameters: '68.2M',
    ngcPath: 'nvidia/tao/yolov8_xlarge',
    supportedAugmentations: ['mosaic', 'mixup', 'random_flip', 'hsv_augment'],
    supportsQAT: true,
    supportsKD: true,
  },
  {
    id: 'rtdetr_r101',
    name: 'rtdetr_resnet101',
    displayName: 'RT-DETR ResNet-101',
    task: 'object_detection',
    backbone: 'rtdetr_r101',
    description: 'High-accuracy real-time transformer detector',
    accuracy: 54.3,
    accuracyMetric: 'mAP',
    vramRequired: 14,
    inputSize: '640x640',
    parameters: '76M',
    ngcPath: 'nvidia/tao/rtdetr_r101',
    supportedAugmentations: ['random_flip', 'random_crop', 'mosaic'],
    supportsQAT: true,
    supportsKD: true,
  },
  {
    id: 'rtdetr_l',
    name: 'rtdetr_large',
    displayName: 'RT-DETR Large',
    task: 'object_detection',
    backbone: 'rtdetr_l',
    description: 'Large RT-DETR with HGNetV2 backbone',
    accuracy: 53.0,
    accuracyMetric: 'mAP',
    vramRequired: 12,
    inputSize: '640x640',
    parameters: '32M',
    ngcPath: 'nvidia/tao/rtdetr_large',
    supportedAugmentations: ['random_flip', 'random_crop', 'mosaic', 'mixup'],
    supportsQAT: true,
    supportsKD: true,
  },
  {
    id: 'fasterrcnn_resnet50',
    name: 'fasterrcnn_resnet50_fpn',
    displayName: 'Faster R-CNN ResNet-50',
    task: 'object_detection',
    backbone: 'fasterrcnn_resnet50',
    description: 'Classic two-stage detector with FPN',
    accuracy: 42.7,
    accuracyMetric: 'mAP',
    vramRequired: 8,
    inputSize: '800x1333',
    parameters: '41M',
    ngcPath: 'nvidia/tao/fasterrcnn_resnet50',
    supportedAugmentations: ['random_flip', 'random_crop', 'color_jitter'],
    supportsQAT: true,
    supportsKD: true,
  },
  {
    id: 'retinanet_resnet50',
    name: 'retinanet_resnet50_fpn',
    displayName: 'RetinaNet ResNet-50',
    task: 'object_detection',
    backbone: 'retinanet_resnet50',
    description: 'Single-stage detector with focal loss',
    accuracy: 40.4,
    accuracyMetric: 'mAP',
    vramRequired: 8,
    inputSize: '800x1333',
    parameters: '37M',
    ngcPath: 'nvidia/tao/retinanet_resnet50',
    supportedAugmentations: ['random_flip', 'random_crop', 'color_jitter'],
    supportsQAT: true,
    supportsKD: true,
  },
  {
    id: 'detr_resnet50',
    name: 'detr_resnet50',
    displayName: 'DETR ResNet-50',
    task: 'object_detection',
    backbone: 'detr_resnet50',
    description: 'End-to-end transformer detector',
    accuracy: 44.9,
    accuracyMetric: 'mAP',
    vramRequired: 10,
    inputSize: '800x1333',
    parameters: '41M',
    ngcPath: 'nvidia/tao/detr_resnet50',
    supportedAugmentations: ['random_flip', 'random_crop', 'color_jitter'],
    supportsQAT: false,
    supportsKD: true,
  },
  {
    id: 'ssd_mobilenet',
    name: 'ssd_mobilenetv2',
    displayName: 'SSD MobileNetV2',
    task: 'object_detection',
    backbone: 'ssd_mobilenet',
    description: 'Lightweight detector for mobile and edge',
    accuracy: 22.1,
    accuracyMetric: 'mAP',
    vramRequired: 2,
    inputSize: '320x320',
    parameters: '4.3M',
    ngcPath: 'nvidia/tao/ssd_mobilenetv2',
    supportedAugmentations: ['random_flip', 'random_crop', 'color_jitter'],
    supportsQAT: true,
    supportsKD: true,
  },
  {
    id: 'dino_vitb',
    name: 'dino_vit_base',
    displayName: 'DINO ViT-Base',
    task: 'object_detection',
    backbone: 'dino_vitb',
    description: 'DINO with Vision Transformer backbone',
    accuracy: 50.1,
    accuracyMetric: 'mAP',
    vramRequired: 16,
    inputSize: '800x1333',
    parameters: '86M',
    ngcPath: 'nvidia/tao/dino_vit_base',
    supportedAugmentations: ['random_flip', 'random_crop', 'color_jitter'],
    supportsQAT: false,
    supportsKD: true,
  },
  // Additional Image Classification Models
  {
    id: 'resnet_18',
    name: 'resnet_18',
    displayName: 'ResNet-18',
    task: 'image_classification',
    backbone: 'resnet_18',
    description: 'Lightweight ResNet for fast inference',
    accuracy: 69.8,
    accuracyMetric: 'top1',
    vramRequired: 2,
    inputSize: '224x224',
    parameters: '11.7M',
    ngcPath: 'nvidia/tao/resnet_18',
    supportedAugmentations: ['random_crop', 'random_flip', 'color_jitter', 'cutout'],
    supportsQAT: true,
    supportsKD: true,
  },
  {
    id: 'resnet_34',
    name: 'resnet_34',
    displayName: 'ResNet-34',
    task: 'image_classification',
    backbone: 'resnet_34',
    description: 'Medium-depth ResNet backbone',
    accuracy: 73.3,
    accuracyMetric: 'top1',
    vramRequired: 3,
    inputSize: '224x224',
    parameters: '21.8M',
    ngcPath: 'nvidia/tao/resnet_34',
    supportedAugmentations: ['random_crop', 'random_flip', 'color_jitter', 'cutout'],
    supportsQAT: true,
    supportsKD: true,
  },
  {
    id: 'resnet_152',
    name: 'resnet_152',
    displayName: 'ResNet-152',
    task: 'image_classification',
    backbone: 'resnet_152',
    description: 'Very deep ResNet for maximum accuracy',
    accuracy: 82.8,
    accuracyMetric: 'top1',
    vramRequired: 10,
    inputSize: '224x224',
    parameters: '60.2M',
    ngcPath: 'nvidia/tao/resnet_152',
    supportedAugmentations: ['random_crop', 'random_flip', 'color_jitter', 'cutout'],
    supportsQAT: true,
    supportsKD: true,
  },
  {
    id: 'efficientnet_b1',
    name: 'efficientnet_b1',
    displayName: 'EfficientNet-B1',
    task: 'image_classification',
    backbone: 'efficientnet_b1',
    description: 'Slightly larger EfficientNet variant',
    accuracy: 79.1,
    accuracyMetric: 'top1',
    vramRequired: 3,
    inputSize: '240x240',
    parameters: '7.8M',
    ngcPath: 'nvidia/tao/efficientnet_b1',
    supportedAugmentations: ['random_crop', 'random_flip', 'autoaugment'],
    supportsQAT: true,
    supportsKD: true,
  },
  {
    id: 'efficientnet_b2',
    name: 'efficientnet_b2',
    displayName: 'EfficientNet-B2',
    task: 'image_classification',
    backbone: 'efficientnet_b2',
    description: 'Balanced EfficientNet for accuracy and speed',
    accuracy: 80.1,
    accuracyMetric: 'top1',
    vramRequired: 4,
    inputSize: '260x260',
    parameters: '9.2M',
    ngcPath: 'nvidia/tao/efficientnet_b2',
    supportedAugmentations: ['random_crop', 'random_flip', 'autoaugment'],
    supportsQAT: true,
    supportsKD: true,
  },
  {
    id: 'efficientnet_b3',
    name: 'efficientnet_b3',
    displayName: 'EfficientNet-B3',
    task: 'image_classification',
    backbone: 'efficientnet_b3',
    description: 'Higher accuracy EfficientNet variant',
    accuracy: 81.6,
    accuracyMetric: 'top1',
    vramRequired: 5,
    inputSize: '300x300',
    parameters: '12M',
    ngcPath: 'nvidia/tao/efficientnet_b3',
    supportedAugmentations: ['random_crop', 'random_flip', 'autoaugment'],
    supportsQAT: true,
    supportsKD: true,
  },
  {
    id: 'efficientnet_b5',
    name: 'efficientnet_b5',
    displayName: 'EfficientNet-B5',
    task: 'image_classification',
    backbone: 'efficientnet_b5',
    description: 'Large EfficientNet for high accuracy',
    accuracy: 83.6,
    accuracyMetric: 'top1',
    vramRequired: 12,
    inputSize: '456x456',
    parameters: '30M',
    ngcPath: 'nvidia/tao/efficientnet_b5',
    supportedAugmentations: ['random_crop', 'random_flip', 'autoaugment'],
    supportsQAT: true,
    supportsKD: true,
  },
  {
    id: 'efficientnet_b6',
    name: 'efficientnet_b6',
    displayName: 'EfficientNet-B6',
    task: 'image_classification',
    backbone: 'efficientnet_b6',
    description: 'Very large EfficientNet variant',
    accuracy: 84.0,
    accuracyMetric: 'top1',
    vramRequired: 16,
    inputSize: '528x528',
    parameters: '43M',
    ngcPath: 'nvidia/tao/efficientnet_b6',
    supportedAugmentations: ['random_crop', 'random_flip', 'autoaugment'],
    supportsQAT: true,
    supportsKD: true,
  },
  {
    id: 'efficientnet_b7',
    name: 'efficientnet_b7',
    displayName: 'EfficientNet-B7',
    task: 'image_classification',
    backbone: 'efficientnet_b7',
    description: 'Largest EfficientNet for maximum accuracy',
    accuracy: 84.3,
    accuracyMetric: 'top1',
    vramRequired: 24,
    inputSize: '600x600',
    parameters: '66M',
    ngcPath: 'nvidia/tao/efficientnet_b7',
    supportedAugmentations: ['random_crop', 'random_flip', 'autoaugment'],
    supportsQAT: true,
    supportsKD: true,
  },
  {
    id: 'mobilenetv2',
    name: 'mobilenet_v2',
    displayName: 'MobileNetV2',
    task: 'image_classification',
    backbone: 'mobilenetv2',
    description: 'Efficient mobile classification model',
    accuracy: 72.0,
    accuracyMetric: 'top1',
    vramRequired: 1,
    inputSize: '224x224',
    parameters: '3.5M',
    ngcPath: 'nvidia/tao/mobilenet_v2',
    supportedAugmentations: ['random_crop', 'random_flip', 'color_jitter'],
    supportsQAT: true,
    supportsKD: true,
  },
  {
    id: 'mobilenetv3_small',
    name: 'mobilenetv3_small',
    displayName: 'MobileNetV3 Small',
    task: 'image_classification',
    backbone: 'mobilenetv3_small',
    description: 'Ultra-lightweight mobile model',
    accuracy: 67.4,
    accuracyMetric: 'top1',
    vramRequired: 1,
    inputSize: '224x224',
    parameters: '2.5M',
    ngcPath: 'nvidia/tao/mobilenetv3_small',
    supportedAugmentations: ['random_crop', 'random_flip', 'color_jitter'],
    supportsQAT: true,
    supportsKD: true,
  },
  {
    id: 'mobilenetv3_large',
    name: 'mobilenetv3_large',
    displayName: 'MobileNetV3 Large',
    task: 'image_classification',
    backbone: 'mobilenetv3_large',
    description: 'Efficient mobile model with higher accuracy',
    accuracy: 75.2,
    accuracyMetric: 'top1',
    vramRequired: 2,
    inputSize: '224x224',
    parameters: '5.4M',
    ngcPath: 'nvidia/tao/mobilenetv3_large',
    supportedAugmentations: ['random_crop', 'random_flip', 'color_jitter'],
    supportsQAT: true,
    supportsKD: true,
  },
  {
    id: 'convnext_tiny',
    name: 'convnext_tiny',
    displayName: 'ConvNeXt Tiny',
    task: 'image_classification',
    backbone: 'convnext_tiny',
    description: 'Modern CNN with transformer-inspired design',
    accuracy: 82.1,
    accuracyMetric: 'top1',
    vramRequired: 6,
    inputSize: '224x224',
    parameters: '29M',
    ngcPath: 'nvidia/tao/convnext_tiny',
    supportedAugmentations: ['random_crop', 'random_flip', 'mixup', 'cutmix'],
    supportsQAT: true,
    supportsKD: true,
  },
  {
    id: 'convnext_small',
    name: 'convnext_small',
    displayName: 'ConvNeXt Small',
    task: 'image_classification',
    backbone: 'convnext_small',
    description: 'Balanced ConvNeXt for accuracy and efficiency',
    accuracy: 83.1,
    accuracyMetric: 'top1',
    vramRequired: 10,
    inputSize: '224x224',
    parameters: '50M',
    ngcPath: 'nvidia/tao/convnext_small',
    supportedAugmentations: ['random_crop', 'random_flip', 'mixup', 'cutmix'],
    supportsQAT: true,
    supportsKD: true,
  },
  {
    id: 'convnext_base',
    name: 'convnext_base',
    displayName: 'ConvNeXt Base',
    task: 'image_classification',
    backbone: 'convnext_base',
    description: 'High-capacity ConvNeXt model',
    accuracy: 83.8,
    accuracyMetric: 'top1',
    vramRequired: 14,
    inputSize: '224x224',
    parameters: '89M',
    ngcPath: 'nvidia/tao/convnext_base',
    supportedAugmentations: ['random_crop', 'random_flip', 'mixup', 'cutmix'],
    supportsQAT: true,
    supportsKD: true,
  },
  {
    id: 'convnext_large',
    name: 'convnext_large',
    displayName: 'ConvNeXt Large',
    task: 'image_classification',
    backbone: 'convnext_large',
    description: 'Large ConvNeXt for maximum accuracy',
    accuracy: 84.3,
    accuracyMetric: 'top1',
    vramRequired: 20,
    inputSize: '224x224',
    parameters: '198M',
    ngcPath: 'nvidia/tao/convnext_large',
    supportedAugmentations: ['random_crop', 'random_flip', 'mixup', 'cutmix'],
    supportsQAT: true,
    supportsKD: true,
  },
  {
    id: 'vit_tiny',
    name: 'vit_tiny_patch16',
    displayName: 'ViT-Tiny/16',
    task: 'image_classification',
    backbone: 'vit_tiny',
    description: 'Lightweight Vision Transformer',
    accuracy: 75.5,
    accuracyMetric: 'top1',
    vramRequired: 3,
    inputSize: '224x224',
    parameters: '5.7M',
    ngcPath: 'nvidia/tao/vit_tiny_16',
    supportedAugmentations: ['random_crop', 'random_flip', 'mixup', 'cutmix'],
    supportsQAT: false,
    supportsKD: true,
  },
  {
    id: 'vit_small',
    name: 'vit_small_patch16',
    displayName: 'ViT-Small/16',
    task: 'image_classification',
    backbone: 'vit_small',
    description: 'Small Vision Transformer',
    accuracy: 81.4,
    accuracyMetric: 'top1',
    vramRequired: 6,
    inputSize: '224x224',
    parameters: '22M',
    ngcPath: 'nvidia/tao/vit_small_16',
    supportedAugmentations: ['random_crop', 'random_flip', 'mixup', 'cutmix'],
    supportsQAT: false,
    supportsKD: true,
  },
  {
    id: 'vit_large',
    name: 'vit_large_patch16',
    displayName: 'ViT-Large/16',
    task: 'image_classification',
    backbone: 'vit_large',
    description: 'Large Vision Transformer for high accuracy',
    accuracy: 85.8,
    accuracyMetric: 'top1',
    vramRequired: 24,
    inputSize: '384x384',
    parameters: '307M',
    ngcPath: 'nvidia/tao/vit_large_16',
    supportedAugmentations: ['random_crop', 'random_flip', 'mixup', 'cutmix'],
    supportsQAT: false,
    supportsKD: true,
  },
  {
    id: 'swin_small',
    name: 'swin_small',
    displayName: 'Swin-Small',
    task: 'image_classification',
    backbone: 'swin_small',
    description: 'Small Swin Transformer',
    accuracy: 83.0,
    accuracyMetric: 'top1',
    vramRequired: 10,
    inputSize: '224x224',
    parameters: '50M',
    ngcPath: 'nvidia/tao/swin_small',
    supportedAugmentations: ['random_crop', 'random_flip', 'mixup', 'cutmix'],
    supportsQAT: false,
    supportsKD: true,
  },
  {
    id: 'swin_large',
    name: 'swin_large',
    displayName: 'Swin-Large',
    task: 'image_classification',
    backbone: 'swin_large',
    description: 'Large Swin Transformer for maximum accuracy',
    accuracy: 86.3,
    accuracyMetric: 'top1',
    vramRequired: 32,
    inputSize: '384x384',
    parameters: '197M',
    ngcPath: 'nvidia/tao/swin_large',
    supportedAugmentations: ['random_crop', 'random_flip', 'mixup', 'cutmix'],
    supportsQAT: false,
    supportsKD: true,
  },
  {
    id: 'fan_tiny',
    name: 'fan_tiny_12',
    displayName: 'FAN-Tiny',
    task: 'image_classification',
    backbone: 'fan_tiny',
    description: 'Fully Attentional Network - Tiny variant',
    accuracy: 79.2,
    accuracyMetric: 'top1',
    vramRequired: 4,
    inputSize: '224x224',
    parameters: '7.3M',
    ngcPath: 'nvidia/tao/fan_tiny',
    supportedAugmentations: ['random_crop', 'random_flip', 'mixup', 'cutmix'],
    supportsQAT: false,
    supportsKD: true,
  },
  {
    id: 'fan_small',
    name: 'fan_small_12',
    displayName: 'FAN-Small',
    task: 'image_classification',
    backbone: 'fan_small',
    description: 'Fully Attentional Network - Small variant',
    accuracy: 83.5,
    accuracyMetric: 'top1',
    vramRequired: 8,
    inputSize: '224x224',
    parameters: '28.6M',
    ngcPath: 'nvidia/tao/fan_small',
    supportedAugmentations: ['random_crop', 'random_flip', 'mixup', 'cutmix'],
    supportsQAT: false,
    supportsKD: true,
  },
  {
    id: 'fan_base',
    name: 'fan_base_18',
    displayName: 'FAN-Base',
    task: 'image_classification',
    backbone: 'fan_base',
    description: 'Fully Attentional Network - Base variant',
    accuracy: 84.3,
    accuracyMetric: 'top1',
    vramRequired: 14,
    inputSize: '224x224',
    parameters: '54M',
    ngcPath: 'nvidia/tao/fan_base',
    supportedAugmentations: ['random_crop', 'random_flip', 'mixup', 'cutmix'],
    supportsQAT: false,
    supportsKD: true,
  },
  {
    id: 'gcvit_tiny',
    name: 'gcvit_tiny',
    displayName: 'GCViT-Tiny',
    task: 'image_classification',
    backbone: 'gcvit_tiny',
    description: 'Global Context Vision Transformer - Tiny',
    accuracy: 82.8,
    accuracyMetric: 'top1',
    vramRequired: 5,
    inputSize: '224x224',
    parameters: '28M',
    ngcPath: 'nvidia/tao/gcvit_tiny',
    supportedAugmentations: ['random_crop', 'random_flip', 'mixup', 'cutmix'],
    supportsQAT: false,
    supportsKD: true,
  },
  {
    id: 'gcvit_small',
    name: 'gcvit_small',
    displayName: 'GCViT-Small',
    task: 'image_classification',
    backbone: 'gcvit_small',
    description: 'Global Context Vision Transformer - Small',
    accuracy: 83.9,
    accuracyMetric: 'top1',
    vramRequired: 9,
    inputSize: '224x224',
    parameters: '51M',
    ngcPath: 'nvidia/tao/gcvit_small',
    supportedAugmentations: ['random_crop', 'random_flip', 'mixup', 'cutmix'],
    supportsQAT: false,
    supportsKD: true,
  },
  {
    id: 'gcvit_base',
    name: 'gcvit_base',
    displayName: 'GCViT-Base',
    task: 'image_classification',
    backbone: 'gcvit_base',
    description: 'Global Context Vision Transformer - Base',
    accuracy: 84.5,
    accuracyMetric: 'top1',
    vramRequired: 14,
    inputSize: '224x224',
    parameters: '90M',
    ngcPath: 'nvidia/tao/gcvit_base',
    supportedAugmentations: ['random_crop', 'random_flip', 'mixup', 'cutmix'],
    supportsQAT: false,
    supportsKD: true,
  },

  // =============================================
  // INSTANCE SEGMENTATION MODELS
  // =============================================
  {
    id: 'mask_rcnn_r50',
    name: 'mask_rcnn_resnet50',
    displayName: 'Mask R-CNN ResNet-50',
    task: 'instance_segmentation',
    backbone: 'mask_rcnn_resnet50',
    description: 'Classic instance segmentation with ResNet-50 backbone',
    accuracy: 37.9,
    accuracyMetric: 'mAP',
    vramRequired: 8,
    inputSize: '800x1333',
    parameters: '44M',
    ngcPath: 'nvidia/tao/mask_rcnn_resnet50',
    supportedAugmentations: ['random_flip', 'random_crop', 'multi_scale'],
    supportsQAT: true,
    supportsKD: true,
    pretrainedDataset: 'COCO 2017',
    pretrainedClasses: 80,
    useCases: ['Instance segmentation', 'Object counting', 'Scene understanding', 'Medical imaging'],
    strengths: ['Well-established architecture', 'Good mask quality', 'Extensive documentation'],
    limitations: ['Two-stage pipeline is slower', 'Higher memory usage'],
    paperReference: 'https://arxiv.org/abs/1703.06870',
    license: 'Apache 2.0',
  },
  {
    id: 'mask_rcnn_r101',
    name: 'mask_rcnn_resnet101',
    displayName: 'Mask R-CNN ResNet-101',
    task: 'instance_segmentation',
    backbone: 'mask_rcnn_resnet101',
    description: 'Higher accuracy Mask R-CNN with deeper backbone',
    accuracy: 39.4,
    accuracyMetric: 'mAP',
    vramRequired: 12,
    inputSize: '800x1333',
    parameters: '63M',
    ngcPath: 'nvidia/tao/mask_rcnn_resnet101',
    supportedAugmentations: ['random_flip', 'random_crop', 'multi_scale'],
    supportsQAT: true,
    supportsKD: true,
    pretrainedDataset: 'COCO 2017',
    pretrainedClasses: 80,
    useCases: ['High-accuracy segmentation', 'Research', 'Complex scenes'],
    strengths: ['Better feature extraction', 'Higher accuracy than R50'],
    limitations: ['Higher computational cost', 'Slower inference'],
    paperReference: 'https://arxiv.org/abs/1703.06870',
    license: 'Apache 2.0',
  },
  {
    id: 'mask2former_swin_s',
    name: 'mask2former_swin_small',
    displayName: 'Mask2Former Swin-S',
    task: 'instance_segmentation',
    backbone: 'mask2former_swin_s',
    description: 'Transformer-based universal segmentation model',
    accuracy: 43.7,
    accuracyMetric: 'mAP',
    vramRequired: 12,
    inputSize: '800x1333',
    parameters: '69M',
    ngcPath: 'nvidia/tao/mask2former_swin_small',
    supportedAugmentations: ['random_flip', 'large_scale_jitter', 'color_jitter'],
    supportsQAT: false,
    supportsKD: true,
    pretrainedDataset: 'COCO 2017',
    pretrainedClasses: 80,
    useCases: ['Unified segmentation', 'Panoptic segmentation', 'Research'],
    strengths: ['State-of-the-art performance', 'Unified architecture', 'Works for multiple tasks'],
    limitations: ['Complex training', 'High GPU requirements'],
    paperReference: 'https://arxiv.org/abs/2112.01527',
    license: 'MIT',
  },
  {
    id: 'mask2former_swin_b',
    name: 'mask2former_swin_base',
    displayName: 'Mask2Former Swin-B',
    task: 'instance_segmentation',
    backbone: 'mask2former_swin_b',
    description: 'High-performance Mask2Former with Swin-Base',
    accuracy: 45.2,
    accuracyMetric: 'mAP',
    vramRequired: 18,
    inputSize: '800x1333',
    parameters: '107M',
    ngcPath: 'nvidia/tao/mask2former_swin_base',
    supportedAugmentations: ['random_flip', 'large_scale_jitter', 'color_jitter'],
    supportsQAT: false,
    supportsKD: true,
    pretrainedDataset: 'COCO 2017',
    pretrainedClasses: 80,
    useCases: ['Research benchmarks', 'High-accuracy requirements', 'Complex scenes'],
    strengths: ['Top-tier accuracy', 'Strong transfer learning'],
    limitations: ['Very high GPU requirements', 'Long training time'],
    paperReference: 'https://arxiv.org/abs/2112.01527',
    license: 'MIT',
  },
  {
    id: 'yolov8_seg_m',
    name: 'yolov8_seg_medium',
    displayName: 'YOLOv8-Seg Medium',
    task: 'instance_segmentation',
    backbone: 'yolov8_seg_m',
    description: 'Real-time instance segmentation with YOLOv8',
    accuracy: 40.8,
    accuracyMetric: 'mAP',
    vramRequired: 8,
    inputSize: '640x640',
    parameters: '27.3M',
    ngcPath: 'nvidia/tao/yolov8_seg_medium',
    supportedAugmentations: ['mosaic', 'mixup', 'random_flip', 'hsv_augment'],
    supportsQAT: true,
    supportsKD: true,
    pretrainedDataset: 'COCO 2017',
    pretrainedClasses: 80,
    useCases: ['Real-time segmentation', 'Video analytics', 'Edge deployment'],
    strengths: ['Fast inference', 'Good accuracy-speed tradeoff', 'Easy to deploy'],
    limitations: ['May struggle with small objects', 'Mask quality lower than two-stage'],
    paperReference: 'https://docs.ultralytics.com/',
    license: 'AGPL-3.0',
  },
  {
    id: 'yolov8_seg_l',
    name: 'yolov8_seg_large',
    displayName: 'YOLOv8-Seg Large',
    task: 'instance_segmentation',
    backbone: 'yolov8_seg_l',
    description: 'High-accuracy real-time instance segmentation',
    accuracy: 42.6,
    accuracyMetric: 'mAP',
    vramRequired: 12,
    inputSize: '640x640',
    parameters: '45.9M',
    ngcPath: 'nvidia/tao/yolov8_seg_large',
    supportedAugmentations: ['mosaic', 'mixup', 'random_flip', 'hsv_augment'],
    supportsQAT: true,
    supportsKD: true,
    pretrainedDataset: 'COCO 2017',
    pretrainedClasses: 80,
    useCases: ['Production segmentation', 'Robotics', 'Autonomous systems'],
    strengths: ['Better accuracy than medium', 'Still real-time capable'],
    limitations: ['Higher memory than medium variant'],
    paperReference: 'https://docs.ultralytics.com/',
    license: 'AGPL-3.0',
  },

  // =============================================
  // SEMANTIC SEGMENTATION MODELS
  // =============================================
  {
    id: 'deeplabv3_r50',
    name: 'deeplabv3_resnet50',
    displayName: 'DeepLabV3 ResNet-50',
    task: 'semantic_segmentation',
    backbone: 'deeplabv3_resnet50',
    description: 'Classic semantic segmentation with atrous convolutions',
    accuracy: 77.2,
    accuracyMetric: 'mAP',
    vramRequired: 6,
    inputSize: '513x513',
    parameters: '42M',
    ngcPath: 'nvidia/tao/deeplabv3_resnet50',
    supportedAugmentations: ['random_crop', 'random_flip', 'random_scale'],
    supportsQAT: true,
    supportsKD: true,
    pretrainedDataset: 'Cityscapes',
    pretrainedClasses: 19,
    useCases: ['Autonomous driving', 'Urban scene parsing', 'Map generation'],
    strengths: ['Well-tested architecture', 'Good for dense prediction'],
    limitations: ['May miss fine details', 'Fixed input resolution'],
    paperReference: 'https://arxiv.org/abs/1706.05587',
    license: 'Apache 2.0',
  },
  {
    id: 'deeplabv3plus_r101',
    name: 'deeplabv3plus_resnet101',
    displayName: 'DeepLabV3+ ResNet-101',
    task: 'semantic_segmentation',
    backbone: 'deeplabv3plus_resnet101',
    description: 'Enhanced DeepLab with decoder for better boundaries',
    accuracy: 80.1,
    accuracyMetric: 'mAP',
    vramRequired: 10,
    inputSize: '513x513',
    parameters: '62M',
    ngcPath: 'nvidia/tao/deeplabv3plus_resnet101',
    supportedAugmentations: ['random_crop', 'random_flip', 'random_scale'],
    supportsQAT: true,
    supportsKD: true,
    pretrainedDataset: 'Cityscapes',
    pretrainedClasses: 19,
    useCases: ['High-quality segmentation', 'Medical imaging', 'Satellite imagery'],
    strengths: ['Better boundary recovery', 'Multi-scale features'],
    limitations: ['Higher computational cost'],
    paperReference: 'https://arxiv.org/abs/1802.02611',
    license: 'Apache 2.0',
  },
  {
    id: 'segformer_b2',
    name: 'segformer_b2',
    displayName: 'SegFormer-B2',
    task: 'semantic_segmentation',
    backbone: 'segformer_b2',
    description: 'Efficient transformer for semantic segmentation',
    accuracy: 81.0,
    accuracyMetric: 'mAP',
    vramRequired: 8,
    inputSize: '512x512',
    parameters: '27.4M',
    ngcPath: 'nvidia/tao/segformer_b2',
    supportedAugmentations: ['random_crop', 'random_flip', 'photometric'],
    supportsQAT: false,
    supportsKD: true,
    pretrainedDataset: 'ADE20K',
    pretrainedClasses: 150,
    useCases: ['Scene understanding', 'Indoor segmentation', 'General purpose'],
    strengths: ['Efficient architecture', 'Good accuracy-efficiency ratio'],
    limitations: ['Transformer complexity'],
    paperReference: 'https://arxiv.org/abs/2105.15203',
    license: 'Apache 2.0',
  },
  {
    id: 'segformer_b4',
    name: 'segformer_b4',
    displayName: 'SegFormer-B4',
    task: 'semantic_segmentation',
    backbone: 'segformer_b4',
    description: 'High-capacity SegFormer for best accuracy',
    accuracy: 83.1,
    accuracyMetric: 'mAP',
    vramRequired: 14,
    inputSize: '512x512',
    parameters: '64.1M',
    ngcPath: 'nvidia/tao/segformer_b4',
    supportedAugmentations: ['random_crop', 'random_flip', 'photometric'],
    supportsQAT: false,
    supportsKD: true,
    pretrainedDataset: 'ADE20K',
    pretrainedClasses: 150,
    useCases: ['Research benchmarks', 'Complex scenes', 'Fine-grained segmentation'],
    strengths: ['State-of-the-art performance', 'Robust to domain shift'],
    limitations: ['High memory requirements'],
    paperReference: 'https://arxiv.org/abs/2105.15203',
    license: 'Apache 2.0',
  },
  {
    id: 'unet_r50',
    name: 'unet_resnet50',
    displayName: 'U-Net ResNet-50',
    task: 'semantic_segmentation',
    backbone: 'unet_resnet50',
    description: 'U-Net architecture with ResNet-50 encoder',
    accuracy: 76.5,
    accuracyMetric: 'mAP',
    vramRequired: 6,
    inputSize: '256x256',
    parameters: '32M',
    ngcPath: 'nvidia/tao/unet_resnet50',
    supportedAugmentations: ['random_flip', 'random_rotate', 'elastic_transform'],
    supportsQAT: true,
    supportsKD: true,
    pretrainedDataset: 'ISIC 2018',
    pretrainedClasses: 7,
    useCases: ['Medical imaging', 'Cell segmentation', 'Biomedical applications'],
    strengths: ['Excellent for medical imaging', 'Skip connections preserve detail'],
    limitations: ['Fixed input size', 'May need domain adaptation'],
    paperReference: 'https://arxiv.org/abs/1505.04597',
    license: 'Apache 2.0',
  },

  // =============================================
  // POSE ESTIMATION MODELS
  // =============================================
  {
    id: 'hrnet_w32',
    name: 'hrnet_w32',
    displayName: 'HRNet-W32',
    task: 'pose_estimation',
    backbone: 'hrnet_w32',
    description: 'High-Resolution Network for human pose estimation',
    accuracy: 74.4,
    accuracyMetric: 'mAP',
    vramRequired: 6,
    inputSize: '256x192',
    parameters: '28.5M',
    ngcPath: 'nvidia/tao/hrnet_w32',
    supportedAugmentations: ['random_flip', 'random_rotate', 'half_body'],
    supportsQAT: true,
    supportsKD: true,
    pretrainedDataset: 'COCO Keypoints',
    pretrainedClasses: 17,
    useCases: ['Human pose estimation', 'Sports analysis', 'Fitness tracking'],
    strengths: ['High-resolution representations', 'Good keypoint localization'],
    limitations: ['Single-person estimation', 'Needs person detection'],
    paperReference: 'https://arxiv.org/abs/1902.09212',
    license: 'MIT',
  },
  {
    id: 'hrnet_w48',
    name: 'hrnet_w48',
    displayName: 'HRNet-W48',
    task: 'pose_estimation',
    backbone: 'hrnet_w48',
    description: 'Larger HRNet for higher accuracy pose estimation',
    accuracy: 75.5,
    accuracyMetric: 'mAP',
    vramRequired: 10,
    inputSize: '384x288',
    parameters: '63.6M',
    ngcPath: 'nvidia/tao/hrnet_w48',
    supportedAugmentations: ['random_flip', 'random_rotate', 'half_body'],
    supportsQAT: true,
    supportsKD: true,
    pretrainedDataset: 'COCO Keypoints',
    pretrainedClasses: 17,
    useCases: ['High-accuracy pose estimation', 'Motion capture', 'Rehabilitation'],
    strengths: ['Best-in-class accuracy', 'Detailed keypoint predictions'],
    limitations: ['Higher computational cost'],
    paperReference: 'https://arxiv.org/abs/1902.09212',
    license: 'MIT',
  },
  {
    id: 'vitpose_base',
    name: 'vitpose_base',
    displayName: 'ViTPose-Base',
    task: 'pose_estimation',
    backbone: 'vitpose_base',
    description: 'Vision Transformer for pose estimation',
    accuracy: 75.8,
    accuracyMetric: 'mAP',
    vramRequired: 12,
    inputSize: '256x192',
    parameters: '86M',
    ngcPath: 'nvidia/tao/vitpose_base',
    supportedAugmentations: ['random_flip', 'random_rotate', 'cutout'],
    supportsQAT: false,
    supportsKD: true,
    pretrainedDataset: 'COCO Keypoints',
    pretrainedClasses: 17,
    useCases: ['Research', 'Multi-person pose', 'Cross-domain adaptation'],
    strengths: ['Transformer architecture', 'Good generalization'],
    limitations: ['Requires more data', 'Higher memory'],
    paperReference: 'https://arxiv.org/abs/2204.12484',
    license: 'Apache 2.0',
  },
  {
    id: 'yolov8_pose_m',
    name: 'yolov8_pose_medium',
    displayName: 'YOLOv8-Pose Medium',
    task: 'pose_estimation',
    backbone: 'yolov8_pose_m',
    description: 'Real-time multi-person pose estimation',
    accuracy: 65.3,
    accuracyMetric: 'mAP',
    vramRequired: 6,
    inputSize: '640x640',
    parameters: '26.4M',
    ngcPath: 'nvidia/tao/yolov8_pose_medium',
    supportedAugmentations: ['mosaic', 'random_flip', 'hsv_augment'],
    supportsQAT: true,
    supportsKD: true,
    pretrainedDataset: 'COCO Keypoints',
    pretrainedClasses: 17,
    useCases: ['Real-time applications', 'Multi-person tracking', 'Edge deployment'],
    strengths: ['End-to-end detection + pose', 'Very fast inference'],
    limitations: ['Lower accuracy than two-stage', 'May miss occluded keypoints'],
    paperReference: 'https://docs.ultralytics.com/',
    license: 'AGPL-3.0',
  },
  {
    id: 'yolov8_pose_l',
    name: 'yolov8_pose_large',
    displayName: 'YOLOv8-Pose Large',
    task: 'pose_estimation',
    backbone: 'yolov8_pose_l',
    description: 'High-accuracy real-time pose estimation',
    accuracy: 67.6,
    accuracyMetric: 'mAP',
    vramRequired: 10,
    inputSize: '640x640',
    parameters: '44.4M',
    ngcPath: 'nvidia/tao/yolov8_pose_large',
    supportedAugmentations: ['mosaic', 'random_flip', 'hsv_augment'],
    supportsQAT: true,
    supportsKD: true,
    pretrainedDataset: 'COCO Keypoints',
    pretrainedClasses: 17,
    useCases: ['Production pose estimation', 'Sports tracking', 'Security'],
    strengths: ['Better accuracy', 'Still real-time capable'],
    limitations: ['Higher memory than medium'],
    paperReference: 'https://docs.ultralytics.com/',
    license: 'AGPL-3.0',
  },

  // =============================================
  // ACTION RECOGNITION MODELS
  // =============================================
  {
    id: 'slowfast_r50',
    name: 'slowfast_resnet50',
    displayName: 'SlowFast ResNet-50',
    task: 'action_recognition',
    backbone: 'slowfast_r50',
    description: 'Two-pathway network for video understanding',
    accuracy: 77.0,
    accuracyMetric: 'top1',
    vramRequired: 16,
    inputSize: '8x256x256',
    parameters: '34.5M',
    ngcPath: 'nvidia/tao/slowfast_resnet50',
    supportedAugmentations: ['random_crop', 'random_flip', 'temporal_jitter'],
    supportsQAT: false,
    supportsKD: true,
    pretrainedDataset: 'Kinetics-400',
    pretrainedClasses: 400,
    useCases: ['Video classification', 'Activity detection', 'Surveillance'],
    strengths: ['Captures both spatial and temporal features', 'Good for varied speeds'],
    limitations: ['High memory for video processing'],
    paperReference: 'https://arxiv.org/abs/1812.03982',
    license: 'Apache 2.0',
  },
  {
    id: 'slowfast_r101',
    name: 'slowfast_resnet101',
    displayName: 'SlowFast ResNet-101',
    task: 'action_recognition',
    backbone: 'slowfast_r101',
    description: 'Higher capacity SlowFast for better accuracy',
    accuracy: 78.9,
    accuracyMetric: 'top1',
    vramRequired: 24,
    inputSize: '16x256x256',
    parameters: '53.7M',
    ngcPath: 'nvidia/tao/slowfast_resnet101',
    supportedAugmentations: ['random_crop', 'random_flip', 'temporal_jitter'],
    supportsQAT: false,
    supportsKD: true,
    pretrainedDataset: 'Kinetics-400',
    pretrainedClasses: 400,
    useCases: ['Research benchmarks', 'Complex action recognition'],
    strengths: ['State-of-the-art accuracy', 'Longer temporal context'],
    limitations: ['Very high memory requirements'],
    paperReference: 'https://arxiv.org/abs/1812.03982',
    license: 'Apache 2.0',
  },
  {
    id: 'x3d_m',
    name: 'x3d_medium',
    displayName: 'X3D-M',
    task: 'action_recognition',
    backbone: 'x3d_m',
    description: 'Efficient video network with progressive expansion',
    accuracy: 76.0,
    accuracyMetric: 'top1',
    vramRequired: 8,
    inputSize: '16x224x224',
    parameters: '3.8M',
    ngcPath: 'nvidia/tao/x3d_medium',
    supportedAugmentations: ['random_crop', 'random_flip', 'temporal_sampling'],
    supportsQAT: true,
    supportsKD: true,
    pretrainedDataset: 'Kinetics-400',
    pretrainedClasses: 400,
    useCases: ['Mobile video recognition', 'Edge deployment', 'Real-time analysis'],
    strengths: ['Very efficient', 'Mobile-friendly', 'Low memory'],
    limitations: ['Lower accuracy than larger models'],
    paperReference: 'https://arxiv.org/abs/2004.04730',
    license: 'Apache 2.0',
  },
  {
    id: 'timesformer_base',
    name: 'timesformer_base',
    displayName: 'TimeSformer-Base',
    task: 'action_recognition',
    backbone: 'timesformer_base',
    description: 'Transformer for video understanding',
    accuracy: 78.0,
    accuracyMetric: 'top1',
    vramRequired: 20,
    inputSize: '8x224x224',
    parameters: '121M',
    ngcPath: 'nvidia/tao/timesformer_base',
    supportedAugmentations: ['random_crop', 'random_flip', 'mixup'],
    supportsQAT: false,
    supportsKD: true,
    pretrainedDataset: 'Kinetics-400',
    pretrainedClasses: 400,
    useCases: ['Long-range video understanding', 'Research', 'Complex temporal patterns'],
    strengths: ['Global temporal attention', 'Good for long videos'],
    limitations: ['High computational cost', 'Large memory footprint'],
    paperReference: 'https://arxiv.org/abs/2102.05095',
    license: 'Apache 2.0',
  },
  {
    id: 'videomae_base',
    name: 'videomae_base',
    displayName: 'VideoMAE-Base',
    task: 'action_recognition',
    backbone: 'videomae_base',
    description: 'Self-supervised video transformer',
    accuracy: 81.5,
    accuracyMetric: 'top1',
    vramRequired: 18,
    inputSize: '16x224x224',
    parameters: '87M',
    ngcPath: 'nvidia/tao/videomae_base',
    supportedAugmentations: ['random_crop', 'random_flip', 'temporal_sampling'],
    supportsQAT: false,
    supportsKD: true,
    pretrainedDataset: 'Kinetics-400',
    pretrainedClasses: 400,
    useCases: ['Transfer learning', 'Fine-grained action recognition', 'Research'],
    strengths: ['Excellent pretraining', 'State-of-the-art results', 'Data efficient'],
    limitations: ['Requires fine-tuning', 'High computational cost'],
    paperReference: 'https://arxiv.org/abs/2203.12602',
    license: 'Apache 2.0',
  },

  // =============================================
  // OCR MODELS
  // =============================================
  {
    id: 'ocrnet_hrnet48',
    name: 'ocrnet_hrnet_w48',
    displayName: 'OCRNet HRNet-W48',
    task: 'ocr',
    backbone: 'ocrnet_hrnet_w48',
    description: 'Scene text detection with object-contextual representations',
    accuracy: 81.1,
    accuracyMetric: 'mAP',
    vramRequired: 12,
    inputSize: '512x512',
    parameters: '70.5M',
    ngcPath: 'nvidia/tao/ocrnet_hrnet_w48',
    supportedAugmentations: ['random_crop', 'random_rotate', 'color_jitter'],
    supportsQAT: true,
    supportsKD: true,
    pretrainedDataset: 'Cityscapes + ICDAR',
    pretrainedClasses: 36,
    useCases: ['Scene text detection', 'Document analysis', 'Street signs'],
    strengths: ['Good for scene text', 'Multi-scale detection'],
    limitations: ['May struggle with handwritten text'],
    paperReference: 'https://arxiv.org/abs/1909.11065',
    license: 'MIT',
  },
  {
    id: 'lprnet',
    name: 'lprnet',
    displayName: 'LPRNet',
    task: 'ocr',
    backbone: 'lprnet',
    description: 'License plate recognition network',
    accuracy: 95.2,
    accuracyMetric: 'top1',
    vramRequired: 2,
    inputSize: '94x24',
    parameters: '0.5M',
    ngcPath: 'nvidia/tao/lprnet',
    supportedAugmentations: ['random_brightness', 'random_contrast', 'blur'],
    supportsQAT: true,
    supportsKD: false,
    pretrainedDataset: 'CCPD',
    pretrainedClasses: 68,
    useCases: ['License plate recognition', 'Parking systems', 'Traffic monitoring'],
    strengths: ['Very fast', 'Lightweight', 'Optimized for plates'],
    limitations: ['Only for license plates', 'May need regional adaptation'],
    paperReference: 'https://arxiv.org/abs/1806.10447',
    license: 'Apache 2.0',
  },
  {
    id: 'crnn_vgg',
    name: 'crnn_vgg',
    displayName: 'CRNN-VGG',
    task: 'ocr',
    backbone: 'crnn_vgg',
    description: 'Convolutional recurrent network for text recognition',
    accuracy: 89.6,
    accuracyMetric: 'top1',
    vramRequired: 4,
    inputSize: '100x32',
    parameters: '8.3M',
    ngcPath: 'nvidia/tao/crnn_vgg',
    supportedAugmentations: ['random_brightness', 'random_blur', 'random_noise'],
    supportsQAT: true,
    supportsKD: true,
    pretrainedDataset: 'MJSynth + SynthText',
    pretrainedClasses: 37,
    useCases: ['Text recognition', 'Document digitization', 'Receipt scanning'],
    strengths: ['Good baseline', 'Well-documented', 'Fast inference'],
    limitations: ['Fixed-length output', 'May miss complex fonts'],
    paperReference: 'https://arxiv.org/abs/1507.05717',
    license: 'Apache 2.0',
  },
  {
    id: 'trocr_base',
    name: 'trocr_base',
    displayName: 'TrOCR-Base',
    task: 'ocr',
    backbone: 'trocr_base',
    description: 'Transformer-based OCR with encoder-decoder',
    accuracy: 93.4,
    accuracyMetric: 'top1',
    vramRequired: 10,
    inputSize: '384x384',
    parameters: '334M',
    ngcPath: 'nvidia/tao/trocr_base',
    supportedAugmentations: ['random_crop', 'random_rotate', 'augmax'],
    supportsQAT: false,
    supportsKD: true,
    pretrainedDataset: 'IAM + SROIE',
    pretrainedClasses: 96,
    useCases: ['Handwritten text', 'Historical documents', 'Multi-language OCR'],
    strengths: ['State-of-the-art accuracy', 'Handles handwriting', 'Multi-language'],
    limitations: ['High memory', 'Slower than CNN-based'],
    paperReference: 'https://arxiv.org/abs/2109.10282',
    license: 'MIT',
  },
  {
    id: 'paddleocr_det',
    name: 'paddleocr_det',
    displayName: 'PaddleOCR Detection',
    task: 'ocr',
    backbone: 'paddleocr_det',
    description: 'Lightweight text detection for scene text',
    accuracy: 82.5,
    accuracyMetric: 'mAP',
    vramRequired: 3,
    inputSize: '640x640',
    parameters: '3.5M',
    ngcPath: 'nvidia/tao/paddleocr_det',
    supportedAugmentations: ['random_crop', 'random_rotate', 'color_aug'],
    supportsQAT: true,
    supportsKD: true,
    pretrainedDataset: 'ICDAR 2015 + 2017',
    pretrainedClasses: 1,
    useCases: ['Text localization', 'Document layout', 'Scene text spotting'],
    strengths: ['Very lightweight', 'Fast inference', 'Mobile-ready'],
    limitations: ['Detection only', 'Needs recognition model'],
    paperReference: 'https://arxiv.org/abs/2009.09941',
    license: 'Apache 2.0',
  },
  {
    id: 'paddleocr_rec',
    name: 'paddleocr_rec',
    displayName: 'PaddleOCR Recognition',
    task: 'ocr',
    backbone: 'paddleocr_rec',
    description: 'Lightweight text recognition model',
    accuracy: 91.2,
    accuracyMetric: 'top1',
    vramRequired: 2,
    inputSize: '320x48',
    parameters: '4.5M',
    ngcPath: 'nvidia/tao/paddleocr_rec',
    supportedAugmentations: ['random_brightness', 'random_distort', 'tia_aug'],
    supportsQAT: true,
    supportsKD: true,
    pretrainedDataset: 'MJSynth + SynthText',
    pretrainedClasses: 6623,
    useCases: ['Text recognition', 'Multi-language support', 'Mobile OCR'],
    strengths: ['Multi-language', 'Very efficient', 'Production-ready'],
    limitations: ['Needs detection first', 'May struggle with rare scripts'],
    paperReference: 'https://arxiv.org/abs/2009.09941',
    license: 'Apache 2.0',
  },
];

